export const baseUrl = "https://brightermind.in/administration/api/v1/user/"
export const imageUrl = "https://brightermind.in/administration/public/clients/document/"
export const pdfUrl = "https://brightermind.in/administration/public/billing/"
export const cpbaseUrl = "https://brightermind.in/administration/api/v1/cp/"
export const rmbaseUrl = "https://brightermind.in/administration/api/v1/rm/"
 export const fmbaseUrl = "https://brightermind.in/administration/api/v1/fm/"
// export const baseUrl = "http://65.1.107.90/administration/api/v1/user/"
// export const cpbaseUrl = "http://65.1.107.90/administration/api/v1/cp/"
// export const rmbaseUrl = "http://65.1.107.90/administration/api/v1/rm/"
// export const fmbaseUrl = "http://65.1.107.90/administration/api/v1/fm/"
// export const imageUrl = "http://65.1.107.90/administration/public/clients/document/"
// export const pdfUrl = "http://65.1.107.90/administration/public/billing/"
 